"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreviousWorkspaceIdWatcherMapDispatch = void 0;
var PreviousWorkspaceIdWatcherMapDispatch = function (dispatch) {
    return {
        saveWorkspaceId: function (_a) {
            var workspaceId = _a.workspaceId;
            dispatch({
                type: 'SET_COOKIE_STORAGE',
                description: 'PreviousWorkspaceIdWatcherMapDispatch',
                values: {
                    previousWorkspaceId: workspaceId,
                },
            });
        },
    };
};
exports.PreviousWorkspaceIdWatcherMapDispatch = PreviousWorkspaceIdWatcherMapDispatch;
